import { PayItem } from "@/interface/recharge";
import AlipayPng from "@/image/recharge/Alipay.svg";
import WeChat from "@/image/recharge/WeChat.svg";

export const methodOfPay: Array<PayItem> = [
  {
    name: '支付宝',
    value: 'Alipay',
    imgUrl: AlipayPng,
  },
  {
    name: '微信',
    value: 'WeChat',
    imgUrl: WeChat,
  }
]